import { render, staticRenderFns } from "./EvaluationCommentsModal.vue?vue&type=template&id=32719820&"
import script from "./EvaluationCommentsModal.vue?vue&type=script&lang=js&"
export * from "./EvaluationCommentsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports